module.exports = __webpack_public_path__ + "static/media/IQ.a1520bca.svg";